export const FILE_SIZE_LIMIT = 25 * 1024 * 1024;

export type EformPublishingStatus = "published" | "drafted";
export type WorkflowPublishingStatus = "published" | "drafted";
